export default __webpack_public_path__ + "static/media/NFT_2.c52658bb.jpeg";